import { Link } from 'react-router-dom';
import './Style.css';
import { FiAlignRight, FiSearch } from 'react-icons/fi';
import { useEffect, useState } from 'react';
import { CarouselLearning } from '../components';

const LandingPage = () => {
	const [scrolled, setScrolled] = useState(false);
	const [showMenu, setShowMenu] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const isScrolled = window.scrollY > 50;
			if (isScrolled !== scrolled) {
				setScrolled(isScrolled);
			}
		};

		// Tambahkan event listener untuk scroll
		window.addEventListener('scroll', handleScroll);

		// Membersihkan event listener pada komponen akan unmount
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [scrolled]);

	const navbarImgStyle = {
		height: scrolled ? 70 : 100,
	};

	return (
		<>
			<div
				className={`w-full z-10 fixed top-0 ${
					scrolled ? 'lp-header-scroll' : ''
				}`}
			>
				<div
					onClick={() => {
						setShowMenu(false);
					}}
					className={
						showMenu
							? `h-screen w-screen fixed top-0 z-20 bg-black opacity-50 transition-all`
							: ''
					}
				/>
				<div className="lp-container p-0 ">
					<div className="lp-header">
						<div className="lg:hidden flex flex-1 items-center rounded-md my-[.5rem] bg-white">
							<FiSearch className="text-gray-400 text-[21px] mx-4" />
							<input
								type="text"
								className="border-0 w-full"
								placeholder="Search"
							/>
						</div>
						<img
							src="/assets/imgs/logo-sr12-univ.png"
							alt=""
							style={navbarImgStyle}
							className="lp-img-navbar"
						/>
						<ul
							className={`lp-navbar-menu ${
								showMenu ? 'lp-navbar-menu-show' : ''
							}`}
						>
							<li className="lp-navbar-menu-item">Home</li>
							<li className="lp-navbar-menu-item">Our Program</li>
							<li className="lp-navbar-menu-item">E-Learning</li>
							<li className="lp-navbar-menu-item">Event</li>
							<li className="lp-navbar-menu-item">
								<Link
									className="lp-btn-login"
									to={'/auth'}
								>
									Sign In
								</Link>
							</li>
						</ul>
						<button
							onClick={() => {
								setShowMenu(!showMenu);
							}}
							className="lp-navbar-btn-menu"
						>
							<FiAlignRight />
						</button>
					</div>
				</div>
			</div>
			<section className="section-header pt-[2rem]">
				<div className="lp-container relative">
					<div className="lg:flex items-center flex-wrap min-h-[calc(100vh-100px)]">
						<div className="flex-1 lg:order-last">
							<img
								src="/assets/imgs/image-banner-fix.png"
								alt=""
							/>
						</div>
						<div className="flex-1 my-auto">
							<h1 className="text-[var(--color-lp-primary)] text-[32px] font-bold block w-full text-center lg:text-left">
								"Achieving your goals with
								<br />
								<span className="px-2 py-0 m-0 text-[var(--color-lp-secondry)]">
									SR12 University
								</span>
								by your side"
							</h1>
							<span className="block text-gray-500 mt-3 text-center lg:text-left">
								SR12 University is a global training provider based across the
								Indonesia that specialises in accredited
							</span>
							<div className="w-9/12">
								<div className="hidden lg:flex items-center rounded-full my-[1rem] bg-white">
									<FiSearch className="text-gray-400 text-[21px] mx-4" />
									<input
										type="text"
										className="border-0 w-full"
										placeholder="Search"
									/>
									<button className="rounded-full bg-[var(--color-lp-primary)] px-6 py-3 text-white hover:bg-[var(--color-lp-secondry)]">
										Search
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className="lp-service">
						<div className="lp-service-content">
							<div className="lp-service-icon">
								<img
									src="/assets/imgs/service/cart.png"
									alt=""
								/>
							</div>
							<div className="lp-service-content-description lg:w-10/12">
								<h3 className="lp-service-title">Product Khowledge</h3>
								<p className="lp-service-description">
									Dapatkan panduan komprehensif tentang produk SR12 Skincare.
									Pelajari bahan-bahan, manfaat, dan penggunaan yang tepat.
									Jadilah ahli dalam memberikan rekomendasi produk yang akurat
									kepada pelanggan.
								</p>
							</div>
						</div>
						<div className="lp-service-content">
							<div className="lp-service-icon">
								<img
									src="/assets/imgs/service/speak.png"
									alt=""
								/>
							</div>
							<div className="lp-service-content-description lg:w-10/12">
								<h3 className="lp-service-title">Public Speacking</h3>
								<p className="lp-service-description">
									Tingkatkan kemampuan public speaking Anda. Pelajari cara
									menyampaikan pesan dengan percaya diri, menangani panggung
									dengan baik, dan berkomunikasi dengan impact yang kuat.
								</p>
							</div>
						</div>
						<div className="lp-service-content">
							<div className="lp-service-icon">
								<img
									src="/assets/imgs/service/business.png"
									alt=""
								/>
							</div>
							<div className="lp-service-content-description lg:w-10/12">
								<h3 className="lp-service-title">Business</h3>
								<p className="lp-service-description">
									Amatilah bisnis Anda berkembang pesat dengan program Business
									Class kami. Pelajari strategi pemasaran, manajemen keuangan,
									dan taktik pertumbuhan yang relevan untuk industri kecantikan.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section>
				<div className="lp-container">
					<div className="lp-training py-[2rem] lg:py-[8rem] text-center ">
						<h2 className="font-semibold text-[20px]">Pelatihan</h2>
						<p>
							Melangkah maju bersama kami dengan metode yang inspiratif dan
							edukatif.
						</p>
						<div className="my-8">
							<CarouselLearning />
						</div>
					</div>
				</div>
			</section>
			<section className="lp-join">
				<div className="lp-container">
					<div className="w-10/12 mx-auto">
						<img
							src="/assets/imgs/img-join.png"
							alt=""
						/>
					</div>
				</div>
			</section>
			<section className="lp-testimoni">
				<div className="lp-container">
					<h2 className="font-semibold text-[20px]">Testimoni</h2>
					<div className="lg:flex gap-3 my-4">
						<div className="lp-testimoni-item md:6/12 lg:w-4/12">
							<p className="text-testimoni text-[13px] text-left pt-5 pb-5">
								“Masya allah banyak banget coach yang saya rasakan dengan adanya
								sr12 university membantu mitra2 yang baru join dan yg sudah join
								lebih banyak ilmu yg di kash, kalau untuk saya pribadi
								alhamdulillah semakin banyak dari pribadi saya jadi lebih
								positif dan saya bisa terapkan ke mitra2 saya untuk berfikir
								positif, mitra2 saya juga omsetnya jadi naik setelah ikut
								pelatihan sr12 university.”
							</p>
							<div className="flex items-center text-left">
								<div></div>
								<div>
									<span className="block">Firda Rizkiyah</span>
									<span className="block text-[11px]">
										Distributor SR12 - Jakarta Selatan
									</span>
								</div>
							</div>
						</div>
						<div className="lp-testimoni-item lg:w-4/12">
							<p className="text-testimoni text-[13px] text-left pt-5 pb-5">
								“Alhamdulillah dengan adanya SR12 University jadi semakin banyak
								pengetahuan baru, bertambah nya ilmu. Mitra juga selalu
								bersemangat belajar dan mempraktekkan ilmu nya. Intinya banyak
								hal yang positif yang kami dapatkan dengan adanya program
								pelatihan dari sr12 university..”
							</p>
							<div className="flex items-center text-left">
								<div></div>
								<div>
									<span className="block">Nurrina Dwi S</span>
									<span className="block text-[11px]">
										Distributor SR12 - Banjarbaru, Kalimantan Selatan
									</span>
								</div>
							</div>
						</div>
						<div className="lp-testimoni-item lg:w-4/12">
							<p className="text-testimoni text-[13px] text-left pt-5 pb-5">
								“Alhamdulillah dengan adanya support pelatihan dan training dari
								SR12 University sangat membantu sekali karena sering memberikan
								pengetahuan dan keterampilan, terutama untuk mental pribadi
								semakin percaya diri dalam menghadapi permasalahan bisnis dan
								kehidupan.”
							</p>
							<div className="flex items-center text-left">
								<div></div>
								<div>
									<span className="block">Titi Widiasih </span>
									<span className="block text-[11px]">
										Distributor SR12 - Jakarta Timur
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="lp-footer">
				<div className="lp-container">
					<div className="lp-footer-content">
						<div className="lg:w-2/12">
							<div className="col1">
								<img
									src="/assets/imgs/logo-sr12-univ.png"
									alt=""
									className="w-24"
								/>
							</div>
						</div>
						<div className="col2">
							<div className="ft-title pb-2">Courses</div>
							<ul className="leading-8">
								<li>
									<a
										href="#"
										className="link-hover"
									>
										Categories
									</a>
								</li>
								<li>
									<a
										href="#"
										className="link-hover"
									>
										Offline Courses
									</a>
								</li>
								<li>
									<a
										href="#"
										className="link-hover"
									>
										Video Courses
									</a>
								</li>
							</ul>
						</div>
						<div className="col2">
							<div className="ft-title pb-2">Support</div>
							<ul className="leading-8">
								<li>
									<a
										href="#"
										className="link-hover"
									>
										FAQ
									</a>
								</li>
								<li>
									<a
										href="#"
										className="link-hover"
									>
										Help Center
									</a>
								</li>
								<li>
									<a
										href="#"
										className="link-hover"
									>
										Career
									</a>
								</li>
								<li>
									<a
										href="#"
										className="link-hover"
									>
										Privacy
									</a>
								</li>
							</ul>
						</div>
						<div className="col2">
							<div className="ft-title pb-2">Contact Info</div>
							<ul className="leading-8">
								<li>
									<a
										href="#"
										className="link-hover"
									>
										0251-860-6622
									</a>
								</li>
								<li>
									<a
										href="#"
										className="link-hover"
									>
										stbd@sr12herbalskincare.co.id
									</a>
								</li>
								<li>
									<a
										href="#"
										className="link-hover"
									>
										Gunung Sindur - Kab. Bogor Jawa Barat
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="border-t py-3 text-center border-gray-300">
						Copyright © 2023 | Sinar12 IT Solution
					</div>
				</div>
			</section>
		</>
	);
};

export default LandingPage;
